module.exports = __webpack_public_path__ + "static/img/iphone5.fd08914.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/commonproblem/nobindmsg/iphone/iphone5.png
// module id = jrkp
// module chunks = 0